import {StyledAutocompleteSingleOption} from './_styled'

export const AutoCompleteSingleOption = ({...props}) => {
  return <StyledAutocompleteSingleOption {...props} />
}
